module.exports = __webpack_public_path__ + "static/media/Tyson Pitch.bb092eac.jpg";